import { useEffect, useState } from 'react';

/**
 * state값이 바뀌면 지정된 시간 후 자동으로 default state로 리셋되는 boolean 상태를 제공하는 커스텀 훅입니다.
 *
 * @param defaultState - 초기 상태값
 * @param resetTimeMs - 상태가 defaultState로 리셋되는 시간(밀리초)
 * @returns [state, setState] - Boolean 상태와 dispatch 함수
 */
export const useTemporaryBooleanState = (
  defaultState: boolean,
  resetTimeMs: number,
) => {
  const [state, setState] = useState<boolean>(defaultState);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (state) {
      timer = setTimeout(() => {
        setState(prev => !prev);
      }, resetTimeMs);
    }

    return () => clearTimeout(timer);
  }, [state, resetTimeMs]);

  return [state, setState] as const;
};
